import objectAssign from './object-assign';

export {
    objectAssign
}



// WEBPACK FOOTER //
// ./web-app/polyfills/index.js